export const DEFAULT_LOCALE = 'en';

export const COUNTRY_CODE_GERMANY = 'DE';

export const CHECKLIST_STATUS = {
    INACTIVE: 0,
    ACTIVE: 10,
};

export const TODO_TYPE = {
    ISSUE: 0,
    INSPECTION: 10,
};

export const TODO_STATUS = {
    OPEN: 0,
    TAKEN: 10,
    DONE: 20,
    CANT_DO: 30,
};

export const INSPECTION_STATUS = {
    EMPTY: 0,
    DONE: 10,
    ARCHIVED: 20,
    CANT_DO: 30,
};

export const ISSUE_STATUS = {
    OPEN: 0,
    SOLVED: 10,
    IN_PROGRESS: 20,
    CANT_DO: 30,
};

export const ISSUE_PRIORITY = {
    LOW: 0,
    MEDIUM: 10,
    HIGH: 20,
};
export const ISSUE_TYPE = {
    SENSOR_ALARM: 'sensor_alarm',
    AUTOMATIC: 'automatic',
    IN_FORM: 'in_form',
    AD_HOC: 'ad_hoc',
};
export const ISSUE_PERMISSIONS = {
    CREATE_PERMISSION_NAME: 'create-issue',
    MANAGE_OWN_PERMISSION_NAME: 'manage-own-issues',
    MANAGE_ALL_PERMISSION_NAME: 'manage-all-issues',
    MANAGE_SITE_PERMISSION_NAME: 'manage-site-issues',
    MANAGE_ASSIGNED_SOLVED_PERMISSION_NAME: 'manage-assigned-solved-issues',
    CREATE_ISSUE_WITH_ASSIGNEE: 'create-issue-with-assignee',
};

export const ISSUE_PAYLOAD_TYPE = {
    IN_FORM: 'in_form',
    AUTOMATIC: 'automatic',
    SENSOR_ALARM: 'sensor_alarm',
};
export const INSPECTION_ITEM_TYPE = {
    INSPECTION: 'inspection',
    FORM: 'form',
    PAGE: 'page',
    SECTION: 'section',
    QUESTION: 'question',
    ACTION: 'action',
    CONDITIONAL: 'conditional_section',
};
export const INSPECTION_ITEM_RESPONSE = {
    TEXT: 'text',
    NUMBER: 'number',
    CHECKBOX: 'checkbox',
    LIST: 'list',
    DATETIME: 'datetime',
    INSTRUCTION: 'instruction',
    ANNOTATION: 'annotation',
    PHOTO: 'photo',
    SIGNATURE: 'signature',
};
export const INSPECTION_RESPONSE_SET_TYPE = {
    DROPDOWN: 'dropdown',
};
export const INSPECTION_NUMBER_CONDITIONS = {
    LESS: '<',
    LESS_EQUAL: '<=',
    EQUAL: '=',
    NOT_EQUAL: '!=',
    GREATER: '>',
    GREATER_EQUAL: '>=',
};
export const INSPECTION_CHECKBOX_CONDITIONS = {
    IS_TRUE: 'is_true',
    IS_FALSE: 'is_false',
};
export const INSPECTION_LIST_CONDITIONS = {
    IS: 'is',
    IS_NOT: 'is_not',
    EMPTY: 'empty',
    NOT_EMPTY: 'not_empty',
    ONE_OF: 'one_of',
    NOT_ONE_OF: 'not_one_of',
    INCLUDES: 'includes',
};

export const SUBSCRIPTION_PLANS = {
    FREE: 'free',
    PROFESSIONAL: 'professional',
};

export const SUBSCRIPTION_INTERVALS = {
    MONTHLY: 'month',
    YEARLY: 'year',
};

export const MILLISECONDS = {
    MS_PER_HOUR: 1000 * 60 * 60,
    MS_PER_DAY: 1000 * 60 * 60 * 24,
};

export const ONBOARDING_TYPE = {
    FIRST_USER: 1,
    FROM_TEMPLATE: 2,
};

export default {
    INSPECTION_STATUS,
    INSPECTION_ITEM_TYPE,
    INSPECTION_ITEM_RESPONSE,
    INSPECTION_RESPONSE_SET_TYPE,
    CHECKLIST_STATUS,
    TODO_TYPE,
    ISSUE_STATUS,
    ISSUE_PRIORITY,
    ISSUE_PERMISSIONS,
    ISSUE_PAYLOAD_TYPE,
    SUBSCRIPTION_PLANS,
    SUBSCRIPTION_INTERVALS,
    MILLISECONDS,
    ONBOARDING_TYPE,
};
